import React, {useState, useEffect} from 'react';
import {makeStyles} from "@material-ui/core/styles";
import moment from 'moment';
import axios from '../api';
import {Grid, IconButton, Menu, MenuItem} from '@material-ui/core';
import banner1 from '../assets/banner_video1.png';
import banner2 from '../assets/banner_video2.png';
import banner3 from '../assets/banner_video3.png';
import '../App.css';

const darkmode = 'background: rgb(0,24,52);\n' +
    'background: linear-gradient(152deg, rgba(0,24,52,1) 0%, rgba(0,24,52,1) 35%, rgba(4,55,113,1) 92%, rgba(7,90,185,1) 98%);'

const useStyles = makeStyles((theme) => ({
    container: {
        backgroundColor: darkmode,
        height: '100vh',
    },
    main: {
        color: theme.palette.common.white,
        padding: theme.spacing(5),
        overflowY: 'hidden',
        overflowX: 'hidden'
    },
    card: {
        backgroundColor: 'transparent',
        margin: theme.spacing(2),

    },
    section: {
        marginTop: '5  %',
    },
    banner: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '55vh',
        marginLeft: 'auto',
        marginRight: "auto",
        marginTop: 30,
        backgroundColor: 'transparent',
        padding: theme.spacing(2),
    },
    header: {
        position: 'fixed',
        left: 0,
        top: 0,
        width: '100%',
        backgroundColor: darkmode,
        color: 'white',
        textAlign: 'center',
        padding: theme.spacing(2),
    },
    footer: {
        position: 'fixed',
        left: 0,
        bottom: 0,
        width: '100%',
        backgroundColor: darkmode,
        color: 'white',
        textAlign: 'center',
        padding: theme.spacing(2),
    }

}));

function Painel() {

    const [dataHora, setDataHora] = useState(moment().format('HH:mm'));
    const [showPanel, setShowPanel] = useState(false);
    const [results, setTableData] = useState([]);
    const [tableKey, setTableKey] = useState(0); // add key to table component
    //use state ta bela
    const [tabelaVisivel, setTabelaVisivel] = useState(true); // Define o estado "tabelaVisivel" como true
    const [anchorEl, setAnchorEl] = useState(null);
    //pega a senha atual que esta sendo exibida no painel do paciente
    const [senhaAtual, setSenhaAtual] = useState('');
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    function handleShow() {
        setTabelaVisivel(!tabelaVisivel); // Alterna o estado "tabelaVisivel" ao clicar no botão
    }

    function fetchData() {
        axios.get('/senha', {timeout: 5000})
            .then(response => {
                const results = response.data.data;
                setTableData(results);
                //pega a segunha atual e realiza as alterações
                if (results.length > 0) {
                    setSenhaAtual(results[0].id);
                }
            })
            .catch(error => {
                console.log('Error fetching data:', error);
            });
    }

    useEffect(() => {
        fetchData();
    }, []);

    // Aqui é onde você pode exibir a primeira senha em um componente diferente
    const primeiraSenha = results.length > 0 ? results[0].name : '';
    //nome
    const senha = results.length > 0 ? results[0].senha : '';


    const classes = useStyles();
    return (
        <div className={classes.container}>
            <main className={classes.main}>
                <div className={classes.header}>
                    <h1>UBS - UNIDADE DE SÃO SEBASTIÃO - SÃO PAULO</h1>
                </div>
                <br/>
                <br/>
                <br/>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={12}>
                        <div className="senha-panel animate__animated animate__backInLeft">
                            <Menu
                                anchorEl={anchorEl}
                                keepMounted
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                            >
                            </Menu>
                            <div className="paciente-header">Aguardando Paciente :</div>
                            <div className="paciente-name">{primeiraSenha.toUpperCase()}</div>
                            <div className="senha-header">Senha :</div>
                            <div className="senha-number">{senha}</div>
                        </div>
                    </Grid>
                    <div className={classes.banner}>
                        <div className="slideshow-slide">
                            <img id="banner" src={banner1} alt="Menu"/>
                        </div>
                        <div className="slideshow-slide">
                            <img id="banner" src={banner2} alt="Menu"/>
                        </div>
                        <div className="slideshow-slide">
                            <img id="banner" src={banner3} alt="Menu"/>
                        </div>
                    </div>
                </Grid>

                <br/>
                <div className={classes.footer}>
                    <h1><strong>{dataHora}</strong></h1>
                </div>
            </main>
        </div>
    );
}

export default Painel;


